var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCameroon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.59837C20.853 0.581242 18.4931 0.0107422 16 0.0107422C13.5069 0.0107422 11.147 0.581242 9.0435 1.59837L7.65219 16.0107L9.0435 30.4231C11.147 31.4402 13.5069 32.0107 16 32.0107C18.4931 32.0107 20.853 31.4402 22.9565 30.4231L24.3478 16.0107L22.9565 1.59837Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 10.4456L17.3811 14.6967H21.8516L18.2351 17.3245L19.6164 21.5759L15.9999 18.9484L12.3833 21.5759L13.7649 17.3245L10.1484 14.6967H14.6186L15.9999 10.4456Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.59888C3.69163 4.18675 0 9.66731 0 16.0107C0 22.3541 3.69163 27.8346 9.0435 30.4225V1.59888Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 1.59888V30.4225C28.3079 27.8346 31.9996 22.354 31.9996 16.0107C31.9996 9.66738 28.3079 4.18675 22.9561 1.59888Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCameroon);
export default __webpack_public_path__ + "static/media/flag_cameroon.24cdce0736821ef4a6d2eab647ae7342.svg";
export { ForwardRef as ReactComponent };